import React, { useRef, useState } from "react";
import { Modal, Button, Form, Row, Col, Tab, Nav } from "react-bootstrap";
import { FiUpload } from "react-icons/fi";
import { FiImage } from "react-icons/fi";
const locationData = {
  California: ["Los Angeles", "San Diego", "Fresno", "San Francisco"],
  "New York": ["New York City"],
  Texas: ["Houston"],
  Florida: ["Miami"],
};

const cityCoordinates = {
  "Los Angeles": { lat: 34.0522, lng: -118.2437 },
  "San Diego": { lat: 32.7157, lng: -117.1611 },
  Fresno: { lat: 36.7378, lng: -119.7871 },
  "San Francisco": { lat: 37.7749, lng: -122.4194 },
};

const PostJobModal = ({ show, handleClose, onSave }) => {
  const [activeTab, setActiveTab] = useState("basic");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  // const [image, setImage] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    category: "",
    jobType: "",
    level: "",
    experience: "",
    qualification: "",
    gender: "",
    minSalary: "",
    maxSalary: "",
    expiredDate: "",
    skills: "",
    address: "",
    country: "",
    state: "",
    city: "",
    zipCode: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) setImage(file);
  };

  const handleSave = () => {
    const newJob = {
      ...formData,
      applicants: 0,
      location: `${formData.city}, ${formData.country}`,
      salary: `${formData.minSalary} - ${formData.maxSalary} / month`,
      experience: `${formData.experience} years of experience`,
      icon: "assets/img/icons/default.svg",
      filled: 0,
      total: 25,
      image: image,
    };
    onSave(newJob);
  };

  const getMapSrc = () => {
    if (!city || !cityCoordinates[city]) return "";
    const { lat, lng } = cityCoordinates[city];
    return `https://maps.google.com/maps?q=${lat},${lng}&z=12&output=embed`;
  };
const fileInputRef = useRef(null);

  // Default Image
  const [image, setImage] = useState(
    "https://i.pravatar.cc/150?img=12"
  );

  const handleImage = (e) => {
    const file = e.target.files[0];

    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);

      // Save image locally
      localStorage.setItem("profileImage", imageUrl);
    }
  };


  return (
    <Modal show={show} onHide={handleClose} className="mt-2" size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Post Job</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Tab.Container activeKey={activeTab}>
          <Nav variant="tabs">
            <Nav.Item>
              <Nav.Link eventKey="basic" onClick={() => setActiveTab("basic")}>
                Basic Information
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="location"
                onClick={() => setActiveTab("location")}
              >
                Location
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content className="mt-3">
            {/* BASIC INFO */}
            <Tab.Pane eventKey="basic">
               <div
      style={{
        background: "#f8f9fb",
        border: "1px solid #ececec",
        borderRadius: "8px",
        padding: "20px",
        marginBottom: "20px",
        display: "flex",
        alignItems: "center",
        gap: "20px",
        flexWrap: "wrap",
      }}
    >
      {/* Profile Image */}
      <div
        style={{
          width: "90px",
          height: "90px",
          borderRadius: "50%",
          border: "1px dashed #d9d9d9",
          overflow: "hidden",
          background: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          position: "relative",
        }}
      >
        {image ? (
          <img
            src={image}
            alt="profile"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        ) : (
          <FiImage size={28} color="#c4c4c4" />
        )}
      </div>

      {/* Content */}
      <div style={{ flex: 1, minWidth: "220px" }}>
        <h5
          style={{
            margin: 0,
            fontSize: "19px",
            fontWeight: "600",
            color: "#0f172a",
          }}
        >
          Upload Profile Image
        </h5>

        <p
          style={{
            marginTop: "6px",
            marginBottom: "16px",
            color: "#64748b",
            fontSize: "15px",
          }}
        >
          Image should be below 4 mb
        </p>

        {/* Hidden File Input */}
        <Form.Control
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={handleImage}
          style={{ display: "none" }}
        />

        {/* Buttons */}
        <div
          style={{
            display: "flex",
            gap: "12px",
            flexWrap: "wrap",
          }}
        >
          {/* Upload Button */}
          <button
            type="button"
            onClick={() => fileInputRef.current.click()}
            style={{
              background: "#ff6b1a",
              border: "none",
              color: "#fff",
              padding: "10px 22px",
              borderRadius: "6px",
              fontSize: "14px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "0.3s",
            }}
          >
            Upload
          </button>

          {/* Cancel Button */}
          <button
            type="button"
            onClick={() =>
              setImage("https://i.pravatar.cc/150?img=12")
            }
            style={{
              background: "#fff",
              border: "1px solid #dcdcdc",
              color: "#111827",
              padding: "10px 22px",
              borderRadius: "6px",
              fontSize: "14px",
              fontWeight: "500",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>


              <Form.Group className="mb-3">
                <Form.Label>Job Title</Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Job Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                />
              </Form.Group>

              <Row>
                <Col>
                  <Form.Select
                    name="category"
                    value={formData.category}
                    onChange={handleInputChange}
                  >
                    <option>Select Category</option>
                    <option>iOS Development</option>
                    <option>Website Development</option>
                    <option>Web Application</option>
                    <option>Networking</option>
                  </Form.Select>
                </Col>

                <Col>
                  <Form.Select
                    name="jobType"
                    value={formData.jobType}
                    onChange={handleInputChange}
                  >
                    <option>Select Job Type</option>
                    <option>Full-time</option>
                    <option>Part-time</option>
                  </Form.Select>
                </Col>
              </Row>

              <Row className="mt-3">
                <Col>
                  <Form.Select
                    name="level"
                    value={formData.level}
                    onChange={handleInputChange}
                  >
                    <option>Select Level</option>
                    <option>Team Lead</option>
                    <option>Manager</option>
                    <option>Senior</option>
                    <option>Junior</option>
                  </Form.Select>
                </Col>

                <Col>
                  <Form.Select
                    name="experience"
                    value={formData.experience}
                    onChange={handleInputChange}
                  >
                    <option>Select Experience</option>
                    <option>Entry Level</option>
                    <option>Mid Level</option>
                    <option>Expert</option>
                  </Form.Select>
                </Col>
              </Row>
              <Row className="mt-3">
                {/* Qualification */}
                <Col>
                  <Form.Group>
                    <Form.Label>Qualification *</Form.Label>
                    <Form.Select
                      name="qualification"
                      value={formData.qualification}
                      onChange={handleInputChange}
                    >
                      <option>Select</option>
                      <option>Bachelor's Degree</option>
                      <option>Master's Degree</option>
                      <option>Diploma</option>
                      <option>PhD</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                {/* Gender */}
                <Col>
                  <Form.Group>
                    <Form.Label>Gender *</Form.Label>
                    <Form.Select
                      name="gender"
                      value={formData.gender}
                      onChange={handleInputChange}
                    >
                      <option>Select</option>
                      <option>Male</option>
                      <option>Female</option>
                      <option>Other</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <Form.Select
                    name="minSalary"
                    value={formData.minSalary}
                    onChange={handleInputChange}
                  >
                    <option>Min Salary</option>
                    <option>10K</option>
                    <option>15K</option>
                    <option>20K</option>
                    <option>25K</option>
                    <option>30K</option>
                  </Form.Select>
                </Col>

                <Col>
                  <Form.Select
                    name="maxSalary"
                    value={formData.maxSalary}
                    onChange={handleInputChange}
                  >
                    <option>Max Salary</option>
                    <option>40K</option>
                    <option>50K</option>
                    <option>60K</option>
                    <option>70K</option>
                  </Form.Select>
                </Col>
              </Row>
              <Row className="mt-3">
                {/* Job Expired Date */}
                <Col>
                  <Form.Group>
                    <Form.Label>Job Expired Date *</Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type="date"
                        name="expiredDate"
                        value={formData.expiredDate}
                        onChange={handleInputChange}
                      />
                      <i className="bi bi-calendar position-absolute end-0 top-50 translate-middle-y me-3"></i>
                    </div>
                  </Form.Group>
                </Col>

                {/* Required Skills */}
                <Col>
                  <Form.Group>
                    <Form.Label>Required Skills</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="e.g. React, Node.js"
                      name="skills"
                      value={formData.skills}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Tab.Pane>

            {/* LOCATION */}
            <Tab.Pane eventKey="location">
              {/* Address */}
              <Form.Group className="mb-3">
                <Form.Label>
                  Address <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                />
              </Form.Group>

              {/* Country & State */}
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Country <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      name="country"
                      value={formData.country}
                      onChange={handleInputChange}
                    >
                      <option>Select</option>
                      <option>USA</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      State <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      name="state"
                      value={formData.state}
                      onChange={(e) => {
                        handleInputChange(e);
                        setState(e.target.value);
                        setCity("");
                      }}
                    >
                      <option>Select</option>
                      <option>California</option>
                      <option>New York</option>
                      <option>Texas</option>
                      <option>Florida</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              {/* City & Zip */}
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      City <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      name="city"
                      value={formData.city}
                      onChange={(e) => {
                        handleInputChange(e);
                        setCity(e.target.value);
                      }}
                    >
                      <option>Select</option>
                      {state &&
                        locationData[state]?.map((c, i) => (
                          <option key={i}>{c}</option>
                        ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Zip Code <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="zipCode"
                      value={formData.zipCode}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* MAP SECTION */}
              <div className="map-container mt-3">
                <div className="map-header">
                  <button className="map-btn">
                    Maps <i className="bi bi-box-arrow-up-right ms-1"></i>
                  </button>
                </div>

                <div className="map-frame">
                  <iframe
                    title="map"
                    width="100%"
                    height="250"
                    src={
                      city
                        ? getMapSrc()
                        : "https://maps.google.com/maps?q=USA&z=4&output=embed"
                    }
                    style={{ border: 0 }}
                    allowFullScreen
                  />
                </div>
              </div>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        {activeTab === "basic" ? (
          <Button  className="border border-1 rounded-1"
            style={{ backgroundColor: "#ff6b1a" }}
            onClick={() => setActiveTab("location")}
          >
            Next
          </Button>
        ) : (
          <Button className="border border-1"  style={{ backgroundColor: "#ff6b1a" }} onClick={handleSave}>
            Post Job
          </Button>
        )}
      </Modal.Footer>
      <style>
        {`
               .form-select option:hover {
  background-color: orange !important;
  color: white;
}

/* Bootstrap dropdown menu hover */
.dropdown-item:hover {
  background-color: orange !important;
  color: white !important;
}
  
/* Date icon styling */
.position-relative i {
  pointer-events: none;
  color: #6c757d;
  font-size: 16px;
}

/* Input spacing like design */
.form-label {
  font-size: 14px;
  font-weight: 500;
}

.form-control,
.form-select {
  height: 42px;
  font-size: 14px;
}
  /* Labels */
.form-label {
  font-size: 14px;
  font-weight: 500;
  color: #344054;
}

/* Inputs */
.form-control,
.form-select {
  height: 42px;
  border-radius: 6px;
  font-size: 14px;
}

/* Map Container */
.map-container {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
}

/* Map Header */
.map-header {
  background: #e6f4f8;
  padding: 10px;
}

/* Map Button */
.map-btn {
  background: #fff;
  border: 1px solid #d0d5dd;
  padding: 6px 12px;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
}

.map-btn:hover {
  background: orange;
  color: #fff;
}

/* Map iframe wrapper */
.map-frame iframe {
  display: block;
}`}
      </style>
    </Modal>
  );
};

export default PostJobModal;
